import React from 'react';
import {
  Box, Typography, Paper, Grid, TableBody, TableRow, TableCell, TableContainer, Table, Avatar,
  // Stack, Divider,
} from '@mui/material';

import { styled } from '@mui/material/styles';
// import Divider from '@mui/material/Divider';
import PrecisionManufacturingRoundedIcon from '@mui/icons-material/PrecisionManufacturingRounded';
// import BusinessRoundedIcon from '@mui/icons-material/BusinessRounded';
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
// import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
// import LinkRoundedIcon from '@mui/icons-material/LinkRounded';
import WebAssetRoundedIcon from '@mui/icons-material/WebAssetRounded';
import ApartmentRoundedIcon from '@mui/icons-material/ApartmentRounded';
import { dataConstants } from '../../../../../constants';
import _getTickerTextData from '../../../../../../pages/api/_getTickerTextData';
import useSWR from 'swr';
import { marked } from 'marked';
import sanitize from '../../../../../utils/sanitize';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? 'rgb(10, 25, 41)' : '#fff',
  ...theme.typography.body2,
  height: '100%',
  color: theme.palette.text.secondary,
  // boxShadow: theme.palette.mode === 'dark' ? 0 : '0 0.5px 1px rgb(132 135 154 / 20%), 0 2px 3px rgb(132 135 154 / 10%)',
  boxShadow: theme.palette.mode === 'dark' ? 0 : '0 0.5px 1px rgb(255 255 255 / 20%), 0 2px 3px rgb(255 255 255 / 10%)',
  border: theme.palette.mode === 'dark' ? '1px solid rgb(19, 47, 76)' : '1px solid #eae9ee',
  borderRadius: '7px',
  '& .Item-Head': {
    background: '#fbfbfc',
    borderBottom: '1px solid #eae9ee',
    padding: theme.spacing(1, 2),
    borderRadius: '7px 7px 0 0',
    '& a': {
      textDecoration: 'none',
    },
    '& .option-title': {
      fontWeight: 600,
      color: '#13113c',
      fontSize: '.875rem',
    }
  },
  '& .Item-Body': {
    padding: theme.spacing(1),
  }
}));

const AboutCompany = ({ info, sector, industry }) => {
  const { industry_group } = info || {}
  const { data, error, isLoading } = useSWR(["api/_getTickerTextData", info?.ticker, ""],
    _getTickerTextData, {
    refreshInterval: 12 * 3600000,
    revalidateOnFocus: false,
    keepPreviousData: true,
    onErrorRetry: (error, key, config, revalidate, { retryCount }) => {
      if (error.status === 404) return
      // if (key === 'api/_getTickerTextData') return
      if (retryCount >= 10) return
      setTimeout(() => revalidate({ retryCount }), 5000)
    }
  })
  const { getTickerTextData } = data || {}
  const aiAbout = getTickerTextData && getTickerTextData.length > 0 ? getTickerTextData.find(d => d.halfCode === "TXT_ABOUT")?.value : null
  // const industry = dataConstants.INDUSTRY?.find(d => ((d.shortName === industry_group) || (d.shortName?.includes(industry_group))));
  return (
    <>
      {info && info?.companyName &&
        <Item component="div" className="about-company" itemScope itemType="https://schema.org/Corporation">
          <Box
            className='Item-Head'
            sx={{
              display: 'flex',
              alignItems: 'flex-start',
              px: 0.5,
            }}
          >
            {info?.url ?
              <a target="_blank" rel="noreferrer nofollow" href={`https://${info.url?.replace('https://', '')}`} className="text-decoration-none">
                <Typography component="h3" className="option-title" sx={{ mr: 'auto' }} >
                  About  {info?.companyName}
                </Typography>
              </a>
              :
              <Typography component="h3" className="option-title" sx={{ mr: 'auto' }} >
                About  {info?.companyName}
              </Typography>}
          </Box>
          {/* <Divider sx={{ mb: 2 }} /> */}
          {/* <Stack
            className='Item-Body'
            direction={{ xs: 'column', sm: 'row', md: 'row' }}
            // useFlexGap flexWrap="wrap"
            spacing={{ xs: 1, sm: 1, md: 1 }}
            sx={{ width: '100%' }}
          > */}
          <Grid container spacing={0}>
            <Grid size={{ xs: 12, sm: 7, md: 8.5 }}>
              <Box component="div" sx={{ p: 2, width: { md: '100%', xs: '100%', sm: '100%' }, overflow: 'hidden', }} className="wrapper">
                <Avatar
                  className="avatar"
                  itemProp="logo"
                  alt={info?.ticker} variant="rounded"
                  src={`https://logo.grufity.com/${info?.ticker}.png`}
                  sx={{
                    width: 52, height: 52, mt: .5, mr: 1, borderRadius: "5px", boxShadow: 0, color: '#174c86', '& img': { objectFit: 'contain', borderRadius: "4px" },
                    float: 'left'
                  }}
                >
                  <ApartmentRoundedIcon />
                </Avatar>
                {(info?.description || aiAbout) &&
                  <Typography itemProp="description" variant="body2" sx={{ color: 'text.description', fontSize: '.875rem' }} className="font-weight-0 lh-base  ml-2"
                    dangerouslySetInnerHTML={{ __html: aiAbout ? sanitize(marked(aiAbout)) : sanitize(info?.description?.replace(info?.long_name, '<b>' + info?.long_name + '</b>') || '') }} />}
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 5, md: 3.5 }}>
              <Box component="div" sx={{ p: 2, width: { md: '100%', xs: '100%', sm: '100%' }, '& .MuiTypography-body2': { fontSize: '.875rem' } }}>
                <TableContainer>
                  <Table aria-label="copmany details" size="medium" sx={{ '& th, td': { borderColor: '#eae9ee', } }}>
                    <TableBody>
                      {info?.ceo &&
                        <TableRow
                          sx={{
                            '& th, td': { py: 1.2, }, '&:last-child td, &:last-child th': { border: 0 },
                            '& a': {
                              color: 'text.link', textDecoration: 'none', display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical', overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            }, '& a:hover': { textDecoration: 'underline' }
                          }}
                        >
                          <TableCell component="th" scope="row" align="left" sx={{ display: 'flex', alignItems: 'center', }}>
                            <PersonRoundedIcon sx={{ mr: 1, opacity: 0.65, fontSize: '1rem' }} />&nbsp;<Typography variant="caption" sx={{ fontSize: '.7rem' }}>CEO</Typography>
                          </TableCell>
                          <TableCell align="right">
                            <span itemProp="member" itemScope itemType="https://schema.org/Person">
                              <a target="_blank" rel="noreferrer nofollow" itemProp="url"
                                href={`https://www.google.com/search?q=${info.ceo}&hl=en`}
                                className="text-decoration-none"
                              >
                                <span itemProp="name">{info.ceo}</span>
                                <meta itemProp="jobTitle" content="CEO" />
                              </a>
                            </span>
                          </TableCell>
                        </TableRow>}
                      {info?.url &&
                        <TableRow
                          sx={{
                            '& th, td': { py: 1.2, },
                            '&:last-child td, &:last-child th': { border: 0 },
                            '& a': {
                              color: 'text.link', textDecoration: 'none', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            }, '& a:hover': { textDecoration: 'underline' }
                          }}
                        >
                          <TableCell component="th" scope="row" align="left" sx={{ display: 'flex', alignItems: 'center', }}>
                            <WebAssetRoundedIcon sx={{ mr: 1, opacity: 0.65, fontSize: '1rem' }} />&nbsp;<Typography variant="caption" sx={{ fontSize: '.7rem' }}>WEBSITE</Typography>
                          </TableCell>
                          <TableCell align="right">
                            <a target="_blank" rel="noreferrer nofollow"
                              href={`https://${info.url?.replace('https://', '')}`}
                              className="text-decoration-none"
                            >
                              {info.url?.replace('https://www.', '')}
                            </a>
                          </TableCell>
                        </TableRow>}
                      {sector && sector !== "" ?
                        <TableRow
                          sx={{
                            '& th, td': { py: 1.2, }, '&:last-child td, &:last-child th': { border: 0 },
                            '& a': { color: 'text.link', textDecoration: 'none' }, '& a:hover': { textDecoration: 'underline' }
                          }}
                        >
                          <TableCell component="th" scope="row" align="left" sx={{ display: 'flex', alignItems: 'center', }}>
                            <PrecisionManufacturingRoundedIcon sx={{ mr: 1, opacity: 0.65, fontSize: '1rem' }} />&nbsp;<Typography variant="caption" sx={{ fontSize: '.7rem' }}>SECTOR</Typography>
                          </TableCell>
                          <TableCell align="right">
                            <a target="_blank" rel="noreferrer nofollow"
                              href={`/sectors`}
                              className="text-decoration-none"
                            >
                              {sector}
                            </a>
                          </TableCell>
                        </TableRow> : null}
                      {industry && industry !== "" ?
                        <TableRow
                          sx={{
                            '& th, td': { py: 1.2, }, '&:last-child td, &:last-child th': { border: 0 },
                            '& a': { color: 'text.link', textDecoration: 'none' }, '& a:hover': { textDecoration: 'underline' }
                          }}
                        >
                          <TableCell component="th" scope="row" align="left" sx={{ display: 'flex', alignItems: 'center', }}>
                            <PrecisionManufacturingRoundedIcon sx={{ mr: 1, opacity: 0.65, fontSize: '1rem' }} />&nbsp;<Typography variant="caption" sx={{ fontSize: '.7rem' }}>INDUSTRY</Typography>
                          </TableCell>
                          <TableCell align="right">
                            <a target="_blank" rel="noreferrer nofollow"
                              href={`/sectors/industry/${industry?.replace(/&/g, 'and').replace(/\s/g, '-')?.toLowerCase()}`}
                              className="text-decoration-none"
                            >
                              {industry}
                            </a>
                          </TableCell>
                        </TableRow> :
                        info?.industry_group &&
                        <TableRow
                          sx={{
                            '& th, td': { py: 1.2, }, '&:last-child td, &:last-child th': { border: 0 },
                            '& a': { color: 'text.link', textDecoration: 'none' }, '& a:hover': { textDecoration: 'underline' }
                          }}
                        >
                          <TableCell component="th" scope="row" align="left" sx={{ display: 'flex', alignItems: 'center', }}>
                            <PrecisionManufacturingRoundedIcon sx={{ mr: 1, opacity: 0.65, fontSize: '1rem' }} />&nbsp;<Typography variant="caption" sx={{ fontSize: '.7rem' }}>INDUSTRY</Typography>
                          </TableCell>
                          <TableCell align="right">
                            {/* <a target="_blank" rel="noreferrer nofollow"
                              href={`/sectors/industry/${info?.industry_group?.replace(/&/g, 'and').replace(/\s/g, '-')?.toLowerCase()}`}
                              className="text-decoration-none"
                            > */}
                            {info?.industry_group}
                            {/* </a> */}
                          </TableCell>
                        </TableRow>}
                      {/* {industry && industry.shortName && industry.shortName !== "" ?
                        <TableRow
                          sx={{
                            '& th, td': { py: 1.2, }, '&:last-child td, &:last-child th': { border: 0 },
                            '& a': { color: 'text.link', textDecoration: 'none' }, '& a:hover': { textDecoration: 'underline' }
                          }}
                        >
                          <TableCell component="th" scope="row" align="left" sx={{ display: 'flex', alignItems: 'center', }}>
                            <PrecisionManufacturingRoundedIcon sx={{ mr: 1, opacity: 0.65, fontSize: '1rem' }} />&nbsp;<Typography variant="caption" sx={{ fontSize: '.7rem' }}>INDUSTRY</Typography>
                          </TableCell>
                          <TableCell align="right">
                            <a target="_blank" rel="noreferrer nofollow"
                              href={`/sectors/industry/${industry.shortName?.replace(/&/g, 'and').replace(/\s/g, '-')?.toLowerCase()}`}
                              className="text-decoration-none"
                            >
                              {industry.shortName}
                            </a>
                          </TableCell>
                        </TableRow> :
                        info?.industry_group &&
                        <TableRow
                          sx={{
                            '& th, td': { py: 1.2, }, '&:last-child td, &:last-child th': { border: 0 },
                            '& a': { color: 'text.link', textDecoration: 'none' }, '& a:hover': { textDecoration: 'underline' }
                          }}
                        >
                          <TableCell component="th" scope="row" align="left" sx={{ display: 'flex', alignItems: 'center', }}>
                            <PrecisionManufacturingRoundedIcon sx={{ mr: 1, opacity: 0.65, fontSize: '1rem' }} />&nbsp;<Typography variant="caption" sx={{ fontSize: '.7rem' }}>INDUSTRY</Typography>
                          </TableCell>
                          <TableCell align="right">
                             {info?.industry_group}
                           </TableCell>
                        </TableRow>} */}
                      {info?.employees &&
                        <TableRow
                          sx={{ '& th, td': { py: 1.2, }, '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                          <TableCell component="th" scope="row" align="left" sx={{ display: 'flex', alignItems: 'center', }}>
                            <GroupsRoundedIcon sx={{ mr: 1, opacity: 0.65, fontSize: '1rem' }} />&nbsp;<Typography variant="caption" sx={{ fontSize: '.7rem' }}>EMPLOYEES</Typography>
                          </TableCell>
                          <TableCell align="right"><span itemProp="numberOfEmployees">{info?.employees}</span></TableCell>
                        </TableRow>}
                    </TableBody>
                  </Table>
                </TableContainer>
                {/* {info?.industry &&
                  <Typography component="div" variant="h2" gutterBottom sx={{ display: 'flex', alignItems: 'center', fontSize: '.875rem', mb: 1.4 }} className="company-industry py-1">
                    <PrecisionManufacturingRoundedIcon sx={{ mr: 2, opacity: 0.65, fontSize: '1.1rem' }} />
                    <Typography variant="body2" className="font-weight-0 ml-2"> {info?.industry}</Typography>
                    <ChevronRightRoundedIcon sx={{ mr: 0, opacity: 0.65 }} />
                    <Typography variant="body2" className="font-weight-0 ml-2"> {info?.industry_group}</Typography>
                  </Typography>}
                {info?.ceo &&
                  <Typography component="div" variant="h2" gutterBottom sx={{ display: 'flex', alignItems: 'center', fontSize: '.875rem', mb: 1.4 }} className="company-ceo py-1">
                    <PersonRoundedIcon sx={{ mr: 2, opacity: 0.65, fontSize: '1.1rem' }} />
                    <Typography variant="body2" className="font-weight-0 ml-2"> {info?.ceo}</Typography>
                  </Typography>}
                {info?.url &&
                  <Typography component="div" variant="h2" gutterBottom sx={{ display: 'flex', alignItems: 'center', fontSize: '.975rem', mb: 1.4, '& a': { color: 'text.link', textDecoration: 'none' }, '& a:hover': { textDecoration: 'underline' } }} className="company-url py-1">
                    <LinkRoundedIcon sx={{ mr: 2, opacity: 0.65, fontSize: '1.1rem' }} />
                    <a target="_blank" rel="noreferrer nofollow" href={`https://${info.url}`} className="text-decoration-none">{info.url}</a>
                  </Typography>}
                {info?.employees &&
                  <Typography component="div" variant="h2" gutterBottom sx={{ display: 'flex', alignItems: 'center', fontSize: '.875rem', mb: 0 }} className="company-url py-1">
                    <GroupsRoundedIcon sx={{ mr: 2, opacity: 0.65, fontSize: '1.1rem' }} />
                    <Typography variant="body2" className="font-weight-0 ml-2"> {info?.employees}</Typography>
                  </Typography>} */}
              </Box>
            </Grid>
          </Grid>
          {/* <Divider orientation="vertical" flexItem /> */}
          {/* </Stack> */}
        </Item >}
    </>
  )
}

export default React.memo(AboutCompany);
// export default withLoader((AboutCompany));
